import { useMemo, useState } from "react";
import { useLocationReporter } from "@/components/gps/useLocationReporter";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const mono = "'IBM Plex Mono', monospace";

export default function TrackerPage() {
  const initial = useMemo(() => new URLSearchParams(window.location.search).get("t") || localStorage.getItem("gps_tracker_token") || "", []);
  const [token, setToken] = useState(initial);
  const [input, setInput] = useState(initial);
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [on, setOn] = useState(false);
  const state = useLocationReporter(token ? `${API}/gps/ingest/${token}` : "", on, { wakeLock: true });

  const start = async () => {
    setErr("");
    try {
      const r = await fetch(`${API}/gps/tracker/${encodeURIComponent(input.trim())}`);
      if (!r.ok) throw new Error((await r.json()).detail || "Invalid token");
      setInfo(await r.json());
      setToken(input.trim());
      localStorage.setItem("gps_tracker_token", input.trim());
      setOn(true);
    } catch (e) { setErr(e.message); }
  };

  const c = state.fix;
  const color = state.status === "sending" ? "#00E676" : state.status === "error" ? "#FF5252" : "#FFB000";
  return (
    <div data-testid="tracker-page" style={{ minHeight: "100vh", background: "#05080c", color: "#E8EEF4", fontFamily: mono, padding: 24, display: "flex", flexDirection: "column", gap: 18, maxWidth: 560, margin: "0 auto" }}>
      <div style={{ fontSize: 13, letterSpacing: 3, color: "#7A8A9A" }}>CAD · GPS TRACKER</div>
      {!on ? (
        <>
          <div style={{ fontSize: 28, fontWeight: 700 }}>Link this device</div>
          <div style={{ fontSize: 13, color: "#9AA" }}>Enter the device token from Admin → GPS Tracking. Keep this page open and the screen on while in service.</div>
          <input data-testid="tracker-token-input" value={input} onChange={(e) => setInput(e.target.value)} placeholder="DEVICE TOKEN"
            style={{ padding: 14, fontSize: 18, fontFamily: mono, background: "#0e151d", color: "#FFF", border: "1px solid #2a3a4a", borderRadius: 4 }} />
          {err && <div data-testid="tracker-error" style={{ color: "#FF5252", fontSize: 13 }}>{err}</div>}
          <button data-testid="tracker-start-btn" onClick={start} disabled={!input.trim()}
            style={{ padding: 16, fontSize: 18, fontWeight: 700, fontFamily: mono, background: "#00BFFF", color: "#001018", border: "none", borderRadius: 4, cursor: "pointer" }}>
            START SHARING LOCATION
          </button>
        </>
      ) : (
        <>
          <div data-testid="tracker-unit" style={{ fontSize: 34, fontWeight: 700 }}>{info?.unit_name || "UNASSIGNED"}</div>
          <div style={{ fontSize: 13, color: "#9AA" }}>{info?.name}</div>
          <div data-testid="tracker-status" style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 20, fontWeight: 700, color }}>
            <span style={{ width: 14, height: 14, borderRadius: "50%", background: color, boxShadow: `0 0 12px ${color}` }} />
            {state.status === "sending" ? "LIVE — SHARING" : state.status === "error" ? "ERROR" : "ACQUIRING GPS…"}
          </div>
          {state.error && <div data-testid="tracker-error" style={{ color: "#FF5252", fontSize: 13 }}>{state.error}</div>}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            {[
              ["SPEED", c?.speed != null && c.speed >= 0 ? `${Math.round(c.speed * 2.23694)} MPH` : "—"],
              ["ACCURACY", c ? `±${Math.round(c.accuracy * 3.28)} FT` : "—"],
              ["LAT / LNG", c ? `${c.latitude.toFixed(5)}, ${c.longitude.toFixed(5)}` : "—"],
              ["LAST SENT", state.lastSent ? state.lastSent.toLocaleTimeString("en-US", { hour12: false }) : "—"],
            ].map(([k, v]) => (
              <div key={k} style={{ background: "#0e151d", border: "1px solid #1c2834", borderRadius: 4, padding: 12 }}>
                <div style={{ fontSize: 10, color: "#7A8A9A", letterSpacing: 2 }}>{k}</div>
                <div style={{ fontSize: 16, fontWeight: 700, marginTop: 4 }}>{v}</div>
              </div>
            ))}
          </div>
          <button data-testid="tracker-stop-btn" onClick={() => setOn(false)}
            style={{ padding: 12, fontSize: 14, fontWeight: 700, fontFamily: mono, background: "transparent", color: "#FF8A80", border: "1px solid #FF5252", borderRadius: 4, cursor: "pointer" }}>
            STOP SHARING
          </button>
        </>
      )}
    </div>
  );
}
